import React from "react";

const ArrowRight = ({ iconColor }) => {
  return (
    <svg
      aria-hidden={true}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
    >
      <path
        d="M6.35355 2.64645C6.15829 2.45118 5.84171 2.45118 5.64645 2.64645C5.45118 2.84171 5.45118 3.15829 5.64645 3.35355L6.35355 2.64645ZM11 8L11.3536 8.35355L11.7071 8L11.3536 7.64645L11 8ZM5.64645 12.6464L5.29289 13L6 13.7071L6.35355 13.3536L5.64645 12.6464ZM5.64645 3.35355L10.6464 8.35355L11.3536 7.64645L6.35355 2.64645L5.64645 3.35355ZM10.6464 7.64645L5.64645 12.6464L6.35355 13.3536L11.3536 8.35355L10.6464 7.64645Z"
        fill={iconColor}
      />
    </svg>
  );
};

export { ArrowRight };
